import { ReactNode } from 'react';
import { ApolloProvider } from '@apollo/client';
import { useGraphqlContext } from './graphql';

type ApolloProviderWrapperProps = {
  children: ReactNode;
};

export const ApolloProviderWrapper: React.FC<ApolloProviderWrapperProps> = ({ children }) => {
  const { client } = useGraphqlContext();

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloProviderWrapper;
